<template>
    <div
        class="grid animate-pulse grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-4"
        data-spec-class="description-list-skeleton"
    >
        <div
            v-for="index in size"
            :key="index"
            class="mb-3 sm:col-span-1"
            data-spec-class="description-list-skeleton__row"
        >
            <div class="mb-3 h-4 rounded-sm bg-muted" />
            <div class="h-4 rounded-sm bg-secondary--inverse" />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { defineProps, withDefaults } from 'vue';

interface Props {
    size?: number;
}

withDefaults(defineProps<Props>(), {
    size: 10,
});
</script>
